import { render, staticRenderFns } from "./CeurCard.vue?vue&type=template&id=fef27a46"
import script from "./CeurCard.vue?vue&type=script&lang=js"
export * from "./CeurCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports